import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import BottomNav from './BottomNav';

const API_BASE = (process.env.REACT_APP_API_URL || 'https://bibleduo-game-production.up.railway.app').replace(/\/$/, '');
const MEDALS = ['🥇', '🥈', '🥉'];

export default function LeaderboardPage() {
  const { user } = useAuth();
  const [entries, setEntries]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/api/leaderboard`)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => setEntries(data))
      .catch(() => setError('Impossible de charger le classement.'))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page-content">
      {/* En-tête */}
      <div style={{ textAlign: 'center', margin: '1.25rem 0 1.5rem' }}>
        <div style={{ fontSize: '3rem' }}>🏆</div>
        <h2 style={{ margin: '.35rem 0 .2rem' }}>Classement</h2>
        <p className="text-small">Top 20 joueurs · classés par XP</p>
      </div>

      {/* États */}
      {loading && (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <div style={{ width: 48, height: 4, borderRadius: 99, background: 'rgba(201,168,76,.15)', overflow: 'hidden', margin: '0 auto' }}>
            <div style={{ height: '100%', background: 'var(--gold)', borderRadius: 99, animation: 'loading-bar 1.5s ease-in-out infinite' }} />
          </div>
          <p className="text-small" style={{ marginTop: '.75rem' }}>Chargement…</p>
        </div>
      )}

      {error && (
        <p style={{ textAlign: 'center', color: 'var(--crimson)', padding: '2rem 0' }}>{error}</p>
      )}

      {!loading && !error && entries.length === 0 && (
        <p style={{ textAlign: 'center', color: 'var(--gray-400)', padding: '2rem 0' }}>
          Aucun joueur classé pour l'instant.
        </p>
      )}

      {/* Liste */}
      {!loading && !error && entries.map((entry, i) => {
        const rank        = i + 1;
        const isMe        = user && entry._id === user._id;
        const displayName = entry.profile?.name || entry.name || 'Anonyme';
        const avatar      = entry.profile?.avatar || '📖';
        const xp          = entry.stats?.xp ?? 0;
        const quizzes     = entry.stats?.totalQuizzes ?? 0;

        return (
          <div
            key={entry._id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '.7rem',
              padding: '.6rem .85rem',
              borderRadius: 10,
              marginBottom: '.35rem',
              background: isMe
                ? 'rgba(201,168,76,.15)'
                : rank <= 3
                  ? 'rgba(253,246,227,.045)'
                  : 'rgba(255,255,255,.025)',
              border: `1.5px solid ${
                isMe      ? 'rgba(201,168,76,.55)'  :
                rank === 1 ? 'rgba(255,215,0,.35)'   :
                rank === 2 ? 'rgba(192,192,192,.3)'  :
                rank === 3 ? 'rgba(205,127,50,.3)'   :
                             'rgba(255,255,255,.06)'
              }`,
              transition: 'none',
            }}
          >
            {/* Rang / médaille */}
            <div style={{ width: 28, textAlign: 'center', flexShrink: 0 }}>
              {rank <= 3
                ? <span style={{ fontSize: '1.25rem' }}>{MEDALS[rank - 1]}</span>
                : <span style={{ fontFamily: 'var(--font-display)', color: 'var(--gray-400)', fontSize: '.8rem', fontWeight: 700 }}>{rank}</span>
              }
            </div>

            {/* Avatar */}
            <div style={{ fontSize: '1.45rem', flexShrink: 0 }}>{avatar}</div>

            {/* Nom + parties */}
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{
                fontFamily: 'var(--font-display)',
                fontSize: '.88rem',
                fontWeight: 700,
                color: isMe ? 'var(--gold-light)' : 'var(--parch)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}>
                {displayName}
                {isMe && (
                  <span style={{ fontFamily: 'var(--font-body)', color: 'var(--gold)', fontSize: '.68rem', marginLeft: '.4rem', fontWeight: 400 }}>
                    ◀ vous
                  </span>
                )}
              </div>
              <div className="text-tiny" style={{ marginTop: '.1rem' }}>
                {quizzes} partie{quizzes !== 1 ? 's' : ''}
              </div>
            </div>

            {/* XP */}
            <div style={{ textAlign: 'right', flexShrink: 0 }}>
              <div style={{ fontFamily: 'var(--font-display)', color: 'var(--gold-light)', fontSize: '.95rem', fontWeight: 700 }}>
                {xp.toLocaleString('fr-FR')}
              </div>
              <div style={{ fontSize: '.62rem', color: 'var(--gray-400)' }}>XP</div>
            </div>
          </div>
        );
      })}

      <BottomNav />
    </div>
  );
}
